import React, { FC } from 'react';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import { Theme } from 'evcharging/app/themes';
import InputError from 'evcharging/components/InputError';
import Form from 'evcharging/components/Form';
import useInput from 'evcharging/hooks/useInput';
import useFormResponse from 'evcharging/hooks/useFormResponse';
import ResponsePopup from 'evcharging/components/ResponsePopup';
import sendCalculatorResult from 'evcharging/app/client/sendCalculatorResult';
import Input from 'evcharging/components/Input';
import { CalculatorResultsProps, formatter, } from 'evcharging/containers/ev-calculator/CalculatorResults';
import { oneWord } from 'evcharging/app/validation/filters';
import useI18n from 'evcharging/hooks/useI18n';
import Loader from 'evcharging/components/Loader';
import Button from 'evcharging/components/Button';
import Responsible from 'evcharging/components/Responsible';
import Spacer from 'evcharging/components/Spacer';

const CalculatorSendResult: FC<CalculatorResultsProps> = (props) => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const email = useInput([oneWord]);
  const { chargingPorts, sellType, fee, hoursPerDay, daysPerMonth, ...money } = props;
  const { t } = useI18n();

  const { isLoading, onSubmit, ...popup } = useFormResponse(
    { email },
    async (values: Record<string, string>) => {

      try {
        await sendCalculatorResult({
          ...values,
          ...Object.entries(money).reduce(
            // @ts-ignore
            (acc, [key, value]) => ({ ...acc, [key]: formatter.format(value) }),
            {}
          ),
          fee: formatter.format(fee * chargingPorts),
          link: window.location.href,
          hoursPerDay,
          daysPerMonth,
          chargingPorts,
          sellType,
        });
      } catch (e) {
        console.log(e)
      }

    }
  );

  return (
    <Form onSubmit={onSubmit}>
      <ResponsePopup {...popup} />
      <Spacer value={24} />
      <label className={styles.label}>{t('calculator.send.title')}</label>
      <Responsible fractions={[74, 18]} space={0}>
        <Input
          placeholder={t('calculator.send.email') + '*'}
          name={'email'}
          onChangeValue={email.onChangeValue}
          value={email.value}
          onBlur={() => email.setError('')}
          invalid={!!email.error}
        >
          <InputError message={email.error} />
        </Input>
        <Button type="submit" disabled={isLoading}>
          {isLoading ? <Loader /> : t('calculator.send.button')}
        </Button>
        {/*{isLoading ? (
          <div className={styles.loader}>
            <SmallLoader />
          </div>
        ) : (
          <button className={styles.button} type="submit" disabled={isLoading}>
            <RightArrowIcon />
          </button>
        )}*/}
      </Responsible>
    </Form>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    position: relative;
    margin-top: 24px;
  `,
  label: css`
    display: block;
    font-weight: 600;
    font-size: 20px;
    line-height: 130%;
    margin-bottom: 10px;
  `,
  button: css`
    position: absolute;
    right: 10px;
    top: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: none;
    outline: none;
    cursor: pointer;
    background: ${theme.colors.accent};
  `,
  loader: css`
    position: absolute;
    right: 10px;
    top: 52px;
  `,
});

export default CalculatorSendResult;
